<template>
  <div id="app">
    <GlobalLoading />

    <!-- Student layout -->
    <div v-if="isStudent" class="app__student">
      <!-- Banner -->
      <div>
        <img src="@/assets/img/header.png" alt="Chess Squad Academy" />
      </div>

      <div v-if="isAuthRoute">
        <StudentNavbar />
        <RoomFloating roomId="lobby" />
        <TournamentFloating />
      </div>

      <router-view class="app__container" :key="$route.fullPath" />

      <IdleTimer
        :duration="30 * 60"
        :reminders="[10 * 60]"
        v-if="isAuthRoute"
      />

      <TrackOnlineStatus v-if="isAuthRoute" />
    </div>

    <!-- Teacher layout -->
    <div v-if="isTeacher" class="app__teacher">
      <!-- Banner -->
      <div>
        <img
          src="@/assets/img/header.png"
          alt="Chess Squad Academy"
          style="max-height: 80px"
        />
      </div>

      <TeacherNavbar v-if="isAuthRoute" />
      <TeacherFloating v-if="isAuthRoute" />
      <router-view class="app__container mb-1" :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
import StudentNavbar from "@/components/navbars/StudentNavbar.vue";
import RoomFloating from "@/components/rooms/RoomFloating.vue";
import TournamentFloating from "@/components/tournaments/TournamentFloating.vue";
import IdleTimer from "@/components/timers/IdleTimer.vue";
import { mapGetters, mapActions } from "vuex";
import { initFirestoreTimeOffset, initRtdbPresence } from "@/services/firebase";
import TrackOnlineStatus from "@/components/TrackOnlineStatus.vue";
import GlobalLoading from "@/components/common/GlobalLoading.vue";
import TeacherNavbar from "@/components/navbars/TeacherNavbar.vue";
import TeacherFloating from "@/components/teacher/TeacherFloating.vue";

export default {
  components: {
    StudentNavbar,
    RoomFloating,
    TournamentFloating,
    IdleTimer,
    TrackOnlineStatus,
    GlobalLoading,
    TeacherNavbar,
    TeacherFloating,
  },

  mounted() {
    this.authAction();
  },

  computed: {
    ...mapGetters(["getUser", "isUserAuth"]),

    isAuthRoute() {
      return !this.$route.meta?.skipAuth;
    },

    isStudent() {
      return this.$route.meta?.student ?? true;
    },

    isTeacher() {
      return this.$route.meta?.teacher ?? false;
    },
  },

  methods: {
    ...mapActions(["authAction"]),
  },

  created() {
    initFirestoreTimeOffset();
    initRtdbPresence();
  },
};
</script>

<style scoped>
#app {
  font-family: "Roboto", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: var(--app-background-color);
  background-image: url("./assets/img/background_tile_3.png");
  background-repeat: repeat;
  background-position: top;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  height: 100vh;
  place-items: center;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Thin scrollbar for IE, Edge, Firefox */
* {
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-width: thin; /* Firefox */
}

/* Hide scrollbar for Chrome, Safari */
*::-webkit-scrollbar {
  width: 5px;
}

*::-webkit-scrollbar-track {
  background: none;
}

*::-webkit-scrollbar-thumb {
  background-color: grey;
  border-radius: 5px;
  /* border: 3px solid orange; */
}

.app__student {
  max-width: 1370px;
  width: 98vw;
}

.app__teacher {
  max-width: 1570px;
  width: 98vw;
}

.app__container {
  background-color: white;
  width: 100%;
  min-height: 70vh;
  padding: 1rem;
  padding-bottom: 4rem;
  margin-bottom: 4rem;
  position: relative;
}

.app__dev {
  text-align: right;
  color: grey;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.center {
  margin-left: auto;
  margin-right: auto;
}
</style>
